import React, {useEffect, useState} from 'react';
import {ReportForm, showWarningNotify} from "../../components";
import {Card, CardContent, CircularProgress, Grid} from '@material-ui/core';
import {showNotification, Title} from 'react-admin';
import env from "../../env";
import {downloadFilePost} from "../../components/FileDownload";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import cachedApis from "../../api/cachedApis";


const BcSoDu = ({...props}) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({
        customerIds: [],
        customers: [],
    });
    const [loadingCustomers, setLoadingCustomers] = React.useState(true);

    useEffect(() => {
        cachedApis.getEmployeeUnits('e').then(rs => {
            setValues({...values, customers: rs});
            setLoadingCustomers(false)
        })
    }, [])

    function excelReport() {
        if (!values.customerIds || values.customerIds.length == 0) {
            showWarningNotify("Vui lòng chọn danh sách")
            return
        }
        setLoading(true)
        const data = {
            customerIds: values.customerIds,
        }
        downloadFilePost(`${env.reportURL}/reports/bc-so-du`, 'bc-so-du.xlsx', data).then(r => setLoading(false)).catch(e => setLoading(false))
    }
    function onCustomerSelected(value) {
        const customerIdIds = [];
        const unitIds = [];
        value.forEach(i => {
            const temp = "" + i;
            let zeroIdx = temp.indexOf("0000");
            let lastZeroIdx = -1;
            while (zeroIdx >= 0) {
                lastZeroIdx = zeroIdx;
                zeroIdx = temp.indexOf("0000", zeroIdx + 1);
            }
            if (lastZeroIdx !== -1 && lastZeroIdx < temp.length - 1) {
                let stdId = Number(temp.substr(lastZeroIdx + 4));
                if (!customerIdIds.includes(stdId)) {
                    customerIdIds.push(stdId);
                }
                let unitId = Number(temp.substr(0, lastZeroIdx));
                if (!unitIds.includes(unitId)) {
                    unitIds.push(unitId);
                }
            }
        });
        setValues(
            {...values, customerIds: customerIdIds, unitIds: unitIds});
    }

    return (
        <Card>
            <Title title="resources.bc-so-du.name"/>
            <CardContent>
                <ReportForm
                            excelReport={excelReport}
                            params={values}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <label><b>Danh sách nhân viên *</b></label>
                            <div style={{width: 500, maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                                <div style={{
                                    maxHeight: '600px',
                                    overflow: 'auto',
                                    marginTop: 20
                                }}>
                                    {loadingCustomers ?
                                        <CircularProgress color="secondary"/>
                                        :
                                        <TreeCheckBoxCustomInput data={values.customers}
                                                                 selected={values.cuzIds}
                                                                 expandTopLevel={true}
                                                                 onChange={onCustomerSelected}/>
                                    }
                                </div>
                            </div>
                        </Grid>

                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default compose(
    connect(null, {showNotification})
)(BcSoDu);